module.exports = __webpack_public_path__ + "img/noData.e1b677f8.png";